// App query keys

export const QUERY_KEY_SERVICES_PAGED = 'QUERY_KEY_SERVICES_PAGED'
